export default {
  methods: {
    /**
     * Descarga un archivo desde una URL
     * @param {string} url - URL del archivo a descargar
     * @param {string} [filename] - Nombre opcional para el archivo descargado
     */
    async downloadFile(url, filename) {
      if (!url) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'No se proporcionó URL para descargar')
        return
      }

      try {
        const response = await fetch(url)
        if (!response.ok) {
          throw new Error(`Error al descargar: ${response.status}`)
        }

        const blob = await response.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl

        // Si no se proporciona nombre, intenta extraerlo de la URL
        if (filename) {
          link.download = filename
        } else {
          const urlPath = new URL(url).pathname
          link.download = urlPath.substring(urlPath.lastIndexOf('/') + 1) || 'archivo'
        }

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(downloadUrl)

        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Archivo descargado correctamente')
      } catch (error) {
        console.error('Error al descargar el archivo:', error)
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al descargar el archivo')
      }
    },
  },
}
